import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSignInAlt, faSignOutAlt, faShoppingCart, faUserAlt, faUserEdit,
  faHome, faInfoCircle, faUserPlus, faUnlock, faFileAlt, faPlusSquare,
  faPlus, faMinus, faWrench, faMinusCircle, faSearch, faMapMarkerAlt,
  faPhoneAlt, faDollarSign, faSitemap, faUserCircle, faUsers, faBriefcase, faFolderOpen, faFile,
  faAddressCard, faUserSecret, faEnvelope, faDesktop, faPlusCircle, faTrashAlt, faEye, faEyeSlash,
  faBell, faDonate, faChartPie, faAt, faMailBulk, faTools,
} from '@fortawesome/free-solid-svg-icons';
import {
  faProductHunt,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import App from './app.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import { AUTH_INIT } from './modules/auth/store';
import OutageManager from './modules/outage/outage-manager';

library.add(
  faSignInAlt, faSignOutAlt, faShoppingCart, faUserAlt, faUserEdit,
  faHome, faInfoCircle, faUserPlus, faUnlock, faFileAlt, faPlusSquare,
  faPlus, faMinus, faWrench, faMinusCircle, faSearch, faMapMarkerAlt,
  faPhoneAlt, faDollarSign, faSitemap, faUserCircle, faUsers, faBriefcase, faFolderOpen, faFile,
  faAddressCard, faUserSecret, faEnvelope, faProductHunt, faDesktop, faPlusCircle, faTrashAlt,
  faEye, faEyeSlash, faBell, faDonate, faChartPie, faAt, faMailBulk, faTools,
);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

function initApp() {
  OutageManager.init().then(() => {
    store.dispatch(AUTH_INIT).then(() => {
    // Todo: if the store is not yet initilize due to a network error need to show a message
      new Vue({
        router,
        store,
        render: (h) => h(App),
      }).$mount('#app');
    });
  });
}

initApp();
